import { utilImageLoader } from '@/fo/util/image-loader';

export default utilImageLoader;
